import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Dialog, FakeText, IconButton, Button } from '@totalsoft/rocket-ui';
import { Grid, Table, TableHead, TableRow, TableCell, TableBody, Box } from '@mui/material';
import CloudDownload from '@mui/icons-material/CloudDownload';

export const FacilityReportsListComponent = ({ reports, onCloseReportsModal, onReportDownload }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={true}
      onClose={onCloseReportsModal}
      aria-labelledby='reports-dialog-title'
      maxWidth={'xs'}
      title={t('OfferAction.Reports')}
      content={
        reports == null || !reports.isLoaded ? (
          <FakeText lines={7} />
        ) : (
          <Grid container justifyContent={'center'}>
            <Grid item xs={12}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{t('Reports.ReportName')}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reports.map(report => {
                    return (
                      <TableRow key={report.reportId}>
                        <TableCell>{report.reportName}</TableCell>
                        <TableCell align={'right'}>
                          <span>
                            <IconButton onClick={onReportDownload(report)} tooltip={t('Tooltips.Download')} variant='text' color='primary'>
                              <CloudDownload />
                            </IconButton>
                          </span>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        )
      }
      actions={
        <Box mb={1} mx={1}>
          <Button onClick={onCloseReportsModal} color='primary' variant='outlined'>
            {t('Close')}
          </Button>
        </Box>
      }
    />
  );
};

FacilityReportsListComponent.propTypes = {
  reports: PropTypes.array,
  onCloseReportsModal: PropTypes.func.isRequired,
  onReportDownload: PropTypes.func.isRequired
};

export default FacilityReportsListComponent;
